import apiClient from '../apiClient';

// ==========================================
// Feed-based endpoints (IRIS-374)
// ==========================================

/**
 * Get feed status overview for a customer.
 * Returns all active feeds with health status, last ingestion time, and row counts.
 */
export const getFeedStatus = (customerId) => {
  return apiClient.get(`/reference-data/feeds/status?customerId=${customerId}`);
};

/**
 * Upload a reference data file to the S3 landing zone for a specific feed.
 * Triggers the ingestion pipeline (S3 → SQS → Lambda → PostgreSQL) automatically.
 */
export const uploadFeedFile = (feedId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post(`/reference-data/feeds/${feedId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * Preview a file to detect schema (columns, delimiter, row count) before uploading.
 */
export const previewFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post('/reference-data/feeds/preview', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/**
 * Deactivate a reference data feed.
 */
export const deactivateFeed = (feedId) => {
  return apiClient.put(`/reference-data/feeds/${feedId}/deactivate`);
};

// ==========================================
// Legacy endpoints (kept for backward compatibility)
// ==========================================

export const getReferenceDataSets = (customerId) => {
  return apiClient.get(`/reference-data?customerId=${customerId}`);
};

export const getReferenceDataSet = (id) => {
  return apiClient.get(`/reference-data/${id}`);
};

export const createReferenceDataSet = (data) => {
  return apiClient.post('/reference-data', data);
};

export const updateReferenceDataSchema = (id, schemaData) => {
  return apiClient.put(`/reference-data/${id}/schema`, schemaData);
};

export const triggerManualReload = (id) => {
  return apiClient.post(`/reference-data/${id}/reload`);
};

export const getFileLoadHistory = (id) => {
  return apiClient.get(`/reference-data/${id}/file-loads`);
};
